import { render, staticRenderFns } from "./BrandCases.vue?vue&type=template&id=49db9caa&scoped=true"
import script from "./BrandCases.vue?vue&type=script&lang=js"
export * from "./BrandCases.vue?vue&type=script&lang=js"
import style0 from "./BrandCases.vue?vue&type=style&index=0&id=49db9caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49db9caa",
  null
  
)

export default component.exports